import Vue from 'vue';
import AdminLayout from '../layouts/Admin.vue';
import Dashboard from '../views/Dashboard.vue';
import ManabuaFeaturedVideos from '../views/ManabuaFeaturedVideos.vue';
import ManabuaFeaturedArticles from '../views/ManabuaFeaturedArticles.vue';
import Error from '../views/Error.vue';
import i18n from '../i18n';
import PolylinoCollectionIcons from '../views/PolylinoCollectionIcons.vue';
import EpubGuideGenerator from '../views/EpubGuideGenerator.vue';
import ThePublisher from '../views/ThePublisher.vue';
import MaterialsBulkCreate from '../resources/materials/BulkCreate.vue';
import TheArticlePublisher from '../views/TheArticlePublisher.vue';

/**
 * Error component
 */
// eslint-disable-next-line vue/multi-word-component-names
Vue.component('Error', Error);

export default {
  path: '',
  component: AdminLayout,
  meta: {
    title: i18n.t('routes.home'),
  },
  children: [
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        title: i18n.t('routes.dashboard'),
      },
    },
    {
      path: '/manabua/featured-videos',
      name: 'manabua-featured-videos',
      component: ManabuaFeaturedVideos,
      meta: {
        title: 'Manabua Featured Videos',
      },
    },
    {
      path: '/manabua/featured-articles',
      name: 'manabua-featured-articles',
      component: ManabuaFeaturedArticles,
      meta: {
        title: 'Manabua Featured Articles',
      },
    },
    {
      path: '/manabua/epub-guide-generator',
      name: 'epub-guide-generator',
      component: EpubGuideGenerator,
      meta: {
        title: 'EPUB Guide Generator',
      },
    },
    {
      path: '/polylino/collection-icons',
      name: 'polylino-collection-icons',
      component: PolylinoCollectionIcons,
      meta: {
        title: 'Polylino Collection Icons',
      },
    },
    {
      path: '/the-publisher',
      name: 'the-publisher',
      component: ThePublisher,
      meta: {
        title: 'The Publisher',
      },
    },
    {
      path: '/materials/bulk-create',
      name: 'materials-bulk-create',
      component: MaterialsBulkCreate,
      meta: {
        title: 'Bulk Create Materials',
      },
    },
    {
      path: '/the-article-publisher',
      name: 'the-article-publisher',
      component: TheArticlePublisher,
      meta: {
        title: 'The Article Publisher',
      },
    },
    {
      path: '*',
      component: Error,
      meta: {
        title: i18n.t('routes.not_found'),
      },
    },
  ],
};
